//合同

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 签署状态
 */
class CommonSignState extends UltMeta {
    UNSIGNED = new Meta(0, "双方未签署");
    BUYER_SIGNED = new Meta(1, "买方签署完成");
    SUPPLY_SIGNED = new Meta(2, "供货方签署完成");
    COMPLETED = new Meta(3, "双方签署已完成");
}

export const COMMON_SIGN_STATE = new CommonSignState();

/**
 * 签署对象
 */
class ContractSignObjectType extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "下游采购商-供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "下游采购商-联合采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购商-供应商");
}

export const CONTRACT_SIGN_OBJECT_TYPE = new ContractSignObjectType();

/**
 * 签署方式
 */
class SignMode extends UltMeta {
    ONLINE = new Meta(1, "线上");
    OFFLINE = new Meta(2, "线下");
}

export const SIGN_MODE = new SignMode();

/**
 * 签署状态
 */
class SignState extends UltMeta {
    TO_BE_SIGNED = new Meta(0, "待签署");
    SIGNING_IN_PROGRESS = new Meta(3, "签署中");
    COMPLETED = new Meta(4, "已完成");
}

export const SIGN_STATE = new SignState();

/**
 * 操作类型
 */
class SubmitType extends UltMeta {
    SAVE_AS_DRAFT = new Meta(0, "保存为草稿");
    SAVE_AND_SUBMIT = new Meta(1, "保存并提交");
}

export const SUBMIT_TYPE = new SubmitType();

/**
 * 合同
 */
class ContractState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_SIGNED = new Meta(2, "待签署");
    SIGNING_IN_PROGRESS = new Meta(3, "签署中");
    COMPLETED = new Meta(4, "已完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}

export const CONTRACT_STATE = new ContractState();

/**
 *
 */
class CorrelationTable extends UltMeta {
    PURCHASE_CONTRACT = new Meta(1, "采购合同");
    PURCHASE_GOODS = new Meta(2, "货物单");
    PURCHASE_GOODS_RECEIPT = new Meta(3, "货物签收单");
    PURCHASE_INVOICE = new Meta(4, "发票");
    PURCHASE_PAYMENT = new Meta(5, "付款单");
    PURCHASE_RECONCILIATION = new Meta(6, "对账单");
    SHIPPING_ORDER = new Meta(7, "船运单");
}

export const CORRELATION_TABLE = new CorrelationTable();
